import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { getAllBarcodePrintList } from "../../../../actions/BarcodePrintListAction";
import Rendertable from "./RenderTable";

const BarcodePrintList = ({
    getAllBarcodePrintList, List, updatelist, setUpdatelist 
}) => {
  const [data, setData]= useState();
  useEffect(() => {
    getAllBarcodePrintList().then((res)=>{
      console.log(res);
      setData(res);
    })
  }, []);

    return (
      <div>
        <Rendertable List={data} setUpdatelist={setUpdatelist}  />
      </div>
    );
};

export default connect(null,{
    getAllBarcodePrintList,
})(BarcodePrintList);

